/**
 * Display formatting helpers (web). Pure string utilities, kept out of the
 * design-system kit: several G1 screens render numeric-as-string API values
 * (Postgres `numeric`, sent as strings to preserve precision) and should group
 * them the same way without each re-implementing the regex.
 */

/** Group the integer part of a numeric-as-string with thousands separators,
 *  preserving its decimals verbatim. We never parse to a float — the API sends
 *  numeric columns as strings for precision. "100000.00" -> "100,000.00". */
export function groupDigits(value: string): string {
  const [intPart, frac] = value.split('.');
  const grouped = (intPart ?? '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return frac != null ? `${grouped}.${frac}` : grouped;
}
